export interface MapStyle {
    name: string;
    url: string;
}

export const MAP_STYLES: MapStyle[] = [
    {
        name: "Hybrid",
        url: "https://raw.githubusercontent.com/go2garret/maps/main/src/assets/json/arcgis_hybrid.json"
    },
    {
        name: "Dark",
        url: "https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json"
    },
    {
        name: "Light",
        url: "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json"
    },
    {
        name: "Satellite",
        url: "https://geoserveis.icgc.cat/contextmaps/icgc_orto_hibrida.json"
    }
]; 